import React, { useState } from "react";
import { FormGroup, Row, Col, Card, CardBody, CardHeader, Label, Table } from "reactstrap";
import PropTypes from "prop-types";

import { FormField, SelectFormField } from "../../../../../utils";
import { commissionForm } from ".";

function EventCommissionTab({ events, loading, event, eventErrors, handleChange }) {
  const [selectedEventType, setSelectedEventType] = useState(events.length > 0 ? events[0].type : "");

  const selectedEventIndex = events.findIndex((e) => e.type === selectedEventType);
  const selectedEvent = selectedEventIndex >= 0 ? events[selectedEventIndex] : null;
  const selectedEventData = event[selectedEventIndex];

  return (
    <div className="mt-3">
      {events.length > 0 ? (
        <Card className="mt-3 shadow-sm">
          <CardHeader className="bg-light">
            <div className="d-flex align-items-center">
              <Label className="mb-0 mr-2 font-weight-bold">Type:</Label>
              <div style={{ minWidth: "200px" }}>
                <SelectFormField
                  disabled={loading}
                  value={selectedEventType}
                  name="eventType"
                  selectItems={events}
                  getSelectItemId={(e) => e.type}
                  getSelectItemName={(e) => e.type}
                  onChange={(name, value) => setSelectedEventType(value)}
                />
              </div>
            </div>
          </CardHeader>
          {selectedEvent && (
            <CardBody>
              <Row>
                <Col xs={12} md={6} lg={4}>
                  <FormField
                    disabled={loading}
                    label="Suggested"
                    value={
                      (event[selectedEventIndex] && event[selectedEventIndex].volume) ||
                      selectedEvent.volume ||
                      ""
                    }
                    name="volume"
                    type="number"
                    description={`Must be between ${parseFloat(selectedEvent.min)}
                      ${
                        selectedEvent.minForm === commissionForm.Flat ? ` ${selectedEvent.currencyISO}` : "%"
                      } and ${parseFloat(selectedEvent.max)}
                      ${
                        selectedEvent.maxForm === commissionForm.Flat ? ` ${selectedEvent.currencyISO}` : "%"
                      }.`}
                    error={eventErrors[selectedEventIndex]}
                    onChange={(name, value) => handleChange(name, selectedEventIndex, "event", value)}
                    dataTypeDecimalName="currency"
                  />
                </Col>
                <Col xs={12} md={6} lg={4}>
                  <SelectFormField
                    disabled={loading}
                    label="Form"
                    value={
                      (event[selectedEventIndex] &&
                        event[selectedEventIndex].form &&
                        event[selectedEventIndex].form.trim()) ||
                      selectedEvent.form ||
                      ""
                    }
                    name="form"
                    selectItems={Object.keys(commissionForm)}
                    getSelectItemId={(key) => key}
                    getSelectItemName={(key) =>
                      `${commissionForm[key]} (${
                        key === commissionForm.Flat ? selectedEvent.currencyISO.trim() : "%"
                      })`
                    }
                    onChange={(name, value) => handleChange(name, selectedEventIndex, "event", value)}
                  />
                </Col>
                <Col xs={12} md={6} lg={4}>
                  <FormField
                    disabled={loading}
                    label="Minimum Charge"
                    value={
                      (event[selectedEventIndex] && event[selectedEventIndex].minimum) ||
                      selectedEvent.minimum ||
                      ""
                    }
                    name="minimum"
                    type="number"
                    onChange={(name, value) => handleChange(name, selectedEventIndex, "event", value)}
                    description={`in ${selectedEvent.currencyISO.trim()}`}
                    dataTypeDecimalName="currency"
                  />
                </Col>
                <Col xs={12} md={6} lg={4}>
                  <FormField
                    disabled={loading}
                    label="Formula"
                    value={
                      (event[selectedEventIndex] && event[selectedEventIndex].formula) ||
                      selectedEvent.formula ||
                      ""
                    }
                    name="formula"
                    type="text"
                    onChange={(name, value) => handleChange(name, selectedEventIndex, "event", value)}
                  />
                </Col>
                <Col xs={12} md={6} lg={4}>
                  <div className="form-group">
                    <Label>Adds</Label>
                    <div>
                      <input
                        type="checkbox"
                        disabled={loading}
                        checked={
                          event[selectedEventIndex] && event[selectedEventIndex].formulaadds !== undefined
                            ? event[selectedEventIndex].formulaadds
                            : selectedEvent.formulaadds || false
                        }
                        onChange={(e) =>
                          handleChange("formulaadds", selectedEventIndex, "event", e.target.checked)
                        }
                      />
                    </div>
                  </div>
                </Col>
              </Row>

              {/* Asset Groups Section */}
              {selectedEventData && selectedEventData.Group && selectedEventData.Group.length > 0 && (
                <div className="mt-4">
                  <h6 className="mb-3 font-weight-bold">Asset Groups</h6>
                  <Table responsive hover size="sm">
                    <thead>
                      <tr>
                        <th>Group Name</th>
                        <th>Asset Value</th>
                        <th>Group Volume</th>
                        <th>Group Adds</th>
                        <th>Form</th>
                        <th>Expression</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedEventData.Group.map((group, groupIndex) => (
                        <tr key={`${group.AssetGroupId}-${groupIndex}`}>
                          <td>{group.AssetGroupName}</td>
                          <td>{group.AssetGroupValue}</td>
                          <td>
                            <FormField
                              disabled={loading}
                              value={group.GroupVolume || ""}
                              name="GroupVolume"
                              type="number"
                              onChange={(name, value) =>
                                handleGroupChange(selectedEventIndex, groupIndex, name, value)
                              }
                              dataTypeDecimalName="currency"
                              size="sm"
                            />
                          </td>
                          <td>
                            <input
                              type="checkbox"
                              disabled={loading}
                              checked={group.GroupAdds || false}
                              onChange={(e) =>
                                handleGroupChange(
                                  selectedEventIndex,
                                  groupIndex,
                                  "GroupAdds",
                                  e.target.checked
                                )
                              }
                            />
                          </td>
                          <td>
                            <SelectFormField
                              disabled={loading}
                              value={group.CommissionGroupForm || ""}
                              name="CommissionGroupForm"
                              selectItems={Object.keys(commissionForm)}
                              getSelectItemId={(key) => key}
                              getSelectItemName={(key) =>
                                `${commissionForm[key]} (${
                                  key === commissionForm.Flat ? selectedEvent.currencyISO.trim() : "%"
                                })`
                              }
                              onChange={(name, value) =>
                                handleGroupChange(selectedEventIndex, groupIndex, name, value)
                              }
                            />
                          </td>
                          <td>
                            <FormField
                              disabled={loading}
                              value={group.CommissionGroupExpression || ""}
                              name="CommissionGroupExpression"
                              type="text"
                              onChange={(name, value) =>
                                handleGroupChange(selectedEventIndex, groupIndex, name, value)
                              }
                              size="sm"
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              )}
            </CardBody>
          )}
        </Card>
      ) : (
        <FormGroup>
          <Card className="text-center">
            <CardBody>
              <p className="text-muted mb-0">No event commissions configured</p>
            </CardBody>
          </Card>
        </FormGroup>
      )}
    </div>
  );

  function handleGroupChange(eventIndex, groupIndex, fieldName, value) {
    // Create a custom handler for group changes
    const newEvent = { ...event[eventIndex] };
    if (!newEvent.Group) newEvent.Group = [];
    if (!newEvent.Group[groupIndex]) newEvent.Group[groupIndex] = {};

    newEvent.Group[groupIndex][fieldName] = value;

    // Use the existing handleChange but modify the event object directly
    handleChange("Group", eventIndex, "event", newEvent.Group);
  }
}

EventCommissionTab.propTypes = {
  events: PropTypes.array.isRequired,
  event: PropTypes.array.isRequired,
  eventErrors: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default EventCommissionTab;
